__turbopack_context__.v({
  "accent-lightblue": "Card-module-scss-module__uH_Kia__accent-lightblue",
  "accent-lightblue-subdued": "Card-module-scss-module__uH_Kia__accent-lightblue-subdued",
  "card": "Card-module-scss-module__uH_Kia__card",
  "compact": "Card-module-scss-module__uH_Kia__compact",
  "neutral": "Card-module-scss-module__uH_Kia__neutral",
  "pink": "Card-module-scss-module__uH_Kia__pink",
  "primary": "Card-module-scss-module__uH_Kia__primary",
  "yellow": "Card-module-scss-module__uH_Kia__yellow",
});
